import { Tag } from '../../../../components/tag';
import { Promotion } from '../../../../stores/promotion';
import { getItemProp } from '../../../../utils';
import { PromotionTypeTag } from '../../../../utils/promotion-types';
import style from '../../style.module.scss';

const renderOffer = (_: unknown, record: Promotion) => {
    return (
        <div className={style.tags_container}>
            {record.type === 'in_store' && (
                <PromotionTypeTag type={'in_store'} />
            )}
            {record.category && (
                <Tag variant="blue">
                    {getItemProp(record.category?.items, 'en', 'title')}
                </Tag>
            )}
            {record.promotionalOffer?.items && (
                <Tag variant="purple">
                    {getItemProp(record.promotionalOffer?.items, 'en', 'title')}
                </Tag>
            )}
        </div>
    );
};

export default renderOffer;
